<template>
  <div class="filter-header">
    <div class="filter-header-left">
      <div class="filter-item flex-nowrap">
        <v-btn-toggle
          borderless
          dense
          mandatory
          :value="zoomValue"
          @change="handleChangeZoom"
        >
          <v-tooltip
            v-for="item in zoomList"
            bottom
            :key="item.value"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                min-width="58"
                small
                text
              >
                <v-icon>{{ item.icon }}</v-icon>
              </v-btn>
            </template>
            <span>{{ item.label }}</span>
          </v-tooltip>
        </v-btn-toggle>
        <v-btn-toggle
          borderless
          dense
          multiple
          :value="carListValue"
          @change="handleChangeCars"
        >
          <v-tooltip
            v-for="item in carList"
            bottom
            :key="item.value"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                min-width="38"
                small
                text
              >
                {{ item.label }}
              </v-btn>
            </template>
            <span>{{ item.label }} {{ item.label === '1' ? 'car' : 'cars' }} on the image</span>
          </v-tooltip>
        </v-btn-toggle>
      </div>
      <div class="divider" />
      <div v-if="fullView" class="refresh-container">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn-refresh"
              icon
              small
              @click="refresh.handler"
            >
              <v-icon size="20">$vuetify.icons.refresh</v-icon>
            </v-btn>
          </template>
          <span>Refresh images</span>
        </v-tooltip>
        {{ refresh.label }}
      </div>
      <v-btn
        v-if="!disabledClear"
        color="error"
        icon
        small
        @click="clearFilters"
      >
        <v-icon size="20">mdi-close</v-icon>
      </v-btn>
    </div>
    <v-btn
      icon
      @click="changeSortByDate"
    >
      <v-icon size="24">{{ sortIcon }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { sortByCreatedDate } from '@/constants'

export default {
  name: 'FiltersHeader',
  props: {
    carFilter: {
      type: Object,
    },
    disabledClear: {
      type: Boolean,
      default: false,
    },
    fullView: {
      type: Boolean,
    },
    ordered: {
      type: String,
    },
    refresh: {
      type: Object,
    },
    smartZoom: {
      type: Object,
      required: true,
    },
  },
  computed: {
    carList() {
      return this.carFilter?.items || []
    },
    carListValue() {
      return this.carFilter?.value.map(el => this.carFilter?.items.findIndex(v => v.value === el))
    },
    sortIcon() {
      return this.ordered === sortByCreatedDate.asc ? '$vuetify.icons.arrow-down' : '$vuetify.icons.arrow-up'
    },
    zoomList() {
      return this.smartZoom?.items || []
    },
    zoomValue() {
      return this.smartZoom?.items.findIndex(v => v.value === this.smartZoom?.value)
    },
  },
  methods: {
    changeSortByDate() {
      this.$emit('updateFilters', {
        filter: 'order',
        value: this.ordered === sortByCreatedDate.asc ? sortByCreatedDate.desc : sortByCreatedDate.asc,
      })
    },
    handleChangeCars(indexes) {
      const value = indexes.map(index => this.carFilter?.items[index].value)
      this.carFilter?.handler(value)
    },
    handleChangeZoom(index) {
      if (index === undefined) {
        return
      }
      const value = this.smartZoom?.items[index].value
      this.smartZoom?.handler(value)
    },
    clearFilters() {
      this.$emit('clearFilters')
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 20px 3px 16px;
  background-color: var(--v-blue-lighten-4);
  box-shadow: inset 0px -1px 0px var(--v-blue-lighten-3);
}

.filter-header-left {
  display: flex;
  align-items: center;
  gap: 6px;
}

.filter-item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.divider {
  width: 1px;
  background: var(--v-grey-lighten-2);
}

.refresh-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

::v-deep {
  .v-btn-toggle {
    border: 2px solid var(--v-blue-lighten-2);

    .v-btn {
      color: var(--v-secondary-base);
    }

    .v-btn--active::before {
      background-color: var(--v-blue-lighten-3);
      opacity: 1;
    }
  }

  .btn-refresh {
    path {
      stroke: var(--v-primary-base);
    }
  }
}
</style>
